// UI REDUCERS
export const LOADING_ON = "LOADING_ON";
export const LOADING_OFF = "LOADING_OFF";
export const SET_THEME = "SET_THEME";
export const SET_LANG = "SET_LANG";




// USER REDUCER
export const SET_MY_DATA = "SET_MY_DATA";
export const SET_MOTOR = "SET_MOTOR";
export const SET_USER = "SET_USER";
export const SET_PRODUCT = "SET_PRODUCT";
export const SET_NEWS_BLOGS = "SET_NEWS_BLOGS";
export const SET_ORDERS = "SET_ORDERS";
export const SET_FINANCE = "SET_FINANCE";
export const USER_ERROR = "USER_ERROR";